<div class="page-content">
    @if (showLoading) {
        <div style="text-align: center">
            <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" animationDuration="1.5s"></p-progressSpinner>
            <div class="mt-2 mb-2">
                {{ loadingStr }}
            </div>
        </div>
    }
    <div [style.display]="!showLoading ? 'block' : 'none'">
        @if (linkObjectType && linkObjectUUID) {
            <app-object-store-entry-crud
                [linkObjectType]="linkObjectType"
                [linkObjectUUID]="linkObjectUUID"
            ></app-object-store-entry-crud>
        }
    </div>
</div>
